import Appbar from './Components/appbar';
import Menu from './Components/Menu'
import Footer from './Components/Footer';
import "../style/DashBoard.css";
import React, { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import axios from "axios";
import { useLocation } from "react-router-dom";
  
export default function ExecutiveDashBoard(){

    const location = useLocation();
    const passedState = location.state;
  
    return(
        <>
        <Appbar username={passedState.username} rights={passedState.rights}></Appbar>
        <div className='Dashboard'>
            <Menu username={passedState.username} rights={passedState.rights}></Menu>
        </div>
        <Footer></Footer>
        </>
    );
}
